import { api } from '@/infra/axios';

export const getUserData = async (userId) => {
  return api.get(`/users${userId ? `/${userId}` : ''}`);
};
